module.exports = __webpack_public_path__ + "static/media/UK-Birmingham.b2e44b0d.png";